module.exports = __webpack_public_path__ + "img/fasapay.b5130fd2.svg";